<template>
    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="currentColor" focusable="false" class=" c-qd">
        <g><path d="M0,0h24v24H0V0z" fill="none"></path></g>
        <g><path d="M15,4V3H9v1H4v2h1v13c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V6h1V4H15z M11,17H9V8h2V17z M15,17h-2V8h2V17z"></path></g>
    </svg>
</template>
<script>
export default {
    name: 'DeleteForeverSvg',
}
</script>